import React from 'react';
import { PERIODS } from '../../metadata/fields.js'

function PeriodFilter({ selectedPeriod = 'ytd' , setSelectedPeriod }) {
    const periodButtons = Object.keys(PERIODS).map((period, index) => {
        return (
            <button key={index} className={"clanleaderboard_period-button " + (selectedPeriod === period ? "clanleaderboard_period-button-active" : "") } onClick={() => setSelectedPeriod(period)} type="button">{PERIODS[period].label.toUpperCase()}</button>
        )
    });

    return (
        <>
            <div className="clanleaderboard_border-top"/>
            <section>
                { periodButtons }
            </section>
        </>
    )
}

export default PeriodFilter;
